module.exports = __webpack_public_path__ + "img/desktop3.449591d6.png";